import { DesignChannel } from 'components/NewFileModal/Types'
import { ExternalIntegrationEnum } from 'api/clients/ExternalIntegrationsClient'
import { YoutubePostDetails } from 'components/PostPreviewModal/components/Youtube/YoutubePostDetails'
import { PostDetailsButtons } from 'components/PostPreviewModal/PostDetailsButtons'
import { ResponsiveDesign } from 'screens/blaze/Home/components/ResponsiveDesign'
import { Heading } from 'blaze-ui/Heading/Heading'
import { ScheduledPostShow } from 'api/clients/ScheduledPostsClient'
import Styles from './YoutubeScreen.module.scss'
import { IntegrationPicker } from 'components/PostPreviewModal/IntegrationPicker'

interface YoutubeScreenProps {
  fileId: string
  channel: DesignChannel
  scheduledPost: ScheduledPostShow
  providerName: string
  provider: ExternalIntegrationEnum
  brandKitId?: number
}

export const YoutubeScreen = ({
  fileId,
  channel,
  scheduledPost,
  providerName,
  provider,
  brandKitId,
}: YoutubeScreenProps) => {
  return (
    <div className={Styles.content} data-testid="youtube-screen">
      <div className={Styles.integrationContainer}>
        <Heading level={4}>Setup metadata for your video post</Heading>
        <IntegrationPicker
          scheduledPost={scheduledPost as ScheduledPostShow}
          providerName={providerName}
          provider={provider}
        />
        <YoutubePostDetails
          fileId={fileId}
          channel={channel}
          scheduledPost={scheduledPost}
          brandKitId={brandKitId}
          data-testid="youtube-post-details"
          data-file-id={fileId}
          data-channel={channel}
          data-provider={provider}
          data-brand-kit-id={brandKitId}
        />
        <ResponsiveDesign.Desktop>
          <PostDetailsButtons
            fileId={fileId}
            channel={channel}
            data-testid="post-details-buttons"
            data-file-id={fileId}
            data-channel={channel}
          />
        </ResponsiveDesign.Desktop>
      </div>
    </div>
  )
}
